import {
  makeStyles,
  Toolbar,
  Button,
  Typography,
  SvgIcon,
  Container,
  Grid,
  Box,
  Card,
  CardContent,
  CardHeader,
  Avatar,
  GridList,
  GridListTile,
  GridListTileBar,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { Plans } from "./Plans";

import { ReactComponent as Logo } from "assets/logotron.svg";
import headerImg from "assets/tablet.png";
import isithard from "assets/headphone.jpg";
import certificate from "assets/certificate.png";
import celostni from "assets/celostni.png";
import structure from "assets/computerscreen.png";
import howitworks from "assets/usingApp.jpg";
import image from "assets/image.png";
import river from "assets/river.png";
import brain from "assets/brain.png";
import apple from "assets/apple.png";
import martina from "assets/martina.png";
import veronika from "assets/veronika.png";
import { FaceRounded } from "@material-ui/icons";
import { useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { clsx } from "clsx";

const SCREENSHOT_IMAGES = require.context("assets/screens");

const SECTION_PADDING = 90;

const useStyles = makeStyles((theme) => ({
  back: {
    background: "linear-gradient(180deg, rgba(0,170,171,1) 0%, white 200px)",
    /*linear-gradient(180deg, rgb(0, 170, 171) 0%, rgb(79, 196, 202) 120px) */
  },
  header: {
    display: "flex",
    flexDirection: "column",
  },
  title: { flexGrow: 1 },
  login: { fontWeight: "bold" },

  ul: {
    margin: 0,
    //lineHeight: "150%",
    "& li": {
      marginBottom: "0.5em",
    },
  },

  firstSection: { paddingBottom: 0 },
  logotron: {
    color: "rgba(0,170,171,1)",
    marginBottom: 50,
    fontWeight: "bold",
  },
  section: { paddingBottom: SECTION_PADDING },
  logo: {
    height: 130,
    width: 130,
    marginRight: 20,
  },
  logoTitle: {
    color: "white",
    fontWeight: "bold",
  },
  centered: { textAlign: "center" },
  sectionHead: {
    fontWeight: "bold",
    paddingTop: SECTION_PADDING,
    paddingBottom: SECTION_PADDING,
    textAlign: "center",
  },
  invert: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.default,
  },
  sectionIcon: { maxWidth: "55px" },
  pillarHead: {
    color: "rgba(0,170,171,1)",
    fontWeight: "bold",
    paddingTop: 12,
    paddingBottom: 12,
  },

  galleryThumb: {
    height: "100%",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "all 0.5s ease",
      "&:hover": {
        transform: "scale(1.15)",
      },
    },
  },
}));

const SCREENS = [
  { label: "Řeč - hláska R", img: "r.png" },
  { label: "Slovní zásoba - hláska R", img: "r-zasoba.png" },
  { label: "Řeč - hláska R - množné číslo", img: "r-mnozne.png" },
  { label: "Řeč - hláska R - počet slabik", img: "r-pocetslabik.png" },
  { label: "Řeč - hláska R - urči první slabiku", img: "r-urci.png" },
  { label: "Řeč - slovní zásoba", img: "slovnizasoba.png" },
  { label: "Řeč - oprav chybu", img: "opravchybu.png" },
  { label: "Řeč - utvoř větu", img: "utvorvetu3.png" },
  { label: "Řeč - porozumění - hádej obrázek", img: "porozumeni.png" },
  { label: "Řeč - gramatika - rody", img: "rody.png" },
  { label: "Zrak - barvy", img: "barvy.png" },
  { label: "Zrak - postřeh - dobble", img: "dobble.png" },
  { label: "Zrak - rozdíly - obrázky S a BEZ", img: "obrazkysbez.png" },
  { label: "Grafomotorika", img: "grafomotorika.png" },
  { label: "Sluch - první hláska", img: "prvnihlaska.png" },
  { label: "Sluch - spoj slabiky", img: "spojslabiky.png" },
  { label: "Sluch - spoj hlásky", img: "spojhlasky.png" },
  { label: "Sluch - rytmizace", img: "rytmizace.png" },
  { label: "Logika - je dost židlí", img: "zidle.png" },
  { label: "Logika - souvislosti", img: "souvislosti.png" },
];

const useGalleryStyles = makeStyles({
  galleryThumb: {
    height: "100%",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "all 0.5s ease",
      "&:hover": {
        transform: "scale(1.15)",
      },
    },
  },
});

function Screenshots() {
  const [selected, setSelected] = useState(-1);
  const nextImgIdx = (selected + 1) % SCREENS.length;
  const prevImgIdx = (selected + SCREENS.length - 1) % SCREENS.length;
  const classes = useGalleryStyles();
  return (
    <>
      <GridList cellHeight={180} cols={4} spacing={35}>
        {SCREENS.map((tile, idx) => (
          <GridListTile key={tile.img} onClick={() => setSelected(idx)}>
            <div className={classes.galleryThumb}>
              <img
                src={SCREENSHOT_IMAGES(`./${tile.img}`).default}
                alt={tile.label}
              />
            </div>
            <GridListTileBar title={tile.label} />
          </GridListTile>
        ))}
      </GridList>
      {selected !== -1 && (
        <Lightbox
          mainSrc={SCREENSHOT_IMAGES(`./${SCREENS[selected].img}`).default}
          nextSrc={SCREENSHOT_IMAGES(`./${SCREENS[nextImgIdx].img}`).default}
          prevSrc={SCREENSHOT_IMAGES(`./${SCREENS[prevImgIdx].img}`).default}
          imageTitle={SCREENS[selected].label}
          onMoveNextRequest={() => setSelected(nextImgIdx)}
          onMovePrevRequest={() => setSelected(prevImgIdx)}
          onCloseRequest={() => setSelected(-1)}
          enableZoom={false}
          imagePadding={50}
        />
      )}
    </>
  );
}

export function Welcome() {
  const classes = useStyles();
  return (
    <div className={classes.back}>
      <header className={classes.header}>
        <Toolbar>
          <div className={classes.title}></div>
          <Button
            className={classes.login}
            variant="contained"
            color="secondary"
            to="/app"
            component={Link}
          >
            Vstoupit do aplikace
          </Button>
        </Toolbar>
      </header>
      <Container maxWidth="lg" className={classes.firstSection}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} className={classes.centered}>
            <div style={{ paddingBottom: "80px" }}>
              <SvgIcon
                className={classes.logo}
                component={Logo}
                viewBox="0 0 618 629"
              />
              <Typography className={classes.logotron} variant="h2">
                LOGOTRON
              </Typography>
              <Typography variant="h5" gutterBottom>
                Webová aplikace{" "}
                <strong>
                  pro logopedy, speciální pedagogy a rodiče dětí s poruchami
                  řeči,
                </strong>{" "}
                kteří chtějí hravě - celostně - systematicky zlepšovat
                komunikační dovednosti dítěte.
              </Typography>
              <Typography variant="h5" gutterBottom>
                Určeno pro děti od 3.5 do 7 let.
              </Typography>
            </div>
          </Grid>

          <Grid
            container
            item
            xs={12}
            sm={6}
            direction="column-reverse"
            alignItems="flex-end"
            style={{ padding: "7px" }}
          >
            <div style={{ position: "relative" }}>
              <img
                style={{ maxWidth: "100%" }}
                src={headerImg}
                alt="Logotron na vašem počítači"
              />
            </div>
          </Grid>
        </Grid>
      </Container>
      <Box className={classes.invert}>
        <Container maxWidth="lg" className={classes.section}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h3" className={classes.sectionHead}>
                Je pro vás každodenní cvičení na logopedii s{"\u00A0"}vaším
                dítětem obtížné?
              </Typography>
            </Grid>
            <Grid item xs={12} sm={5}>
              <div style={{ position: "relative" }}>
                <img
                  style={{ maxWidth: "100%" }}
                  src={isithard}
                  alt="Používat aplikaci Logotron je jednoduché"
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={7}>
              <Typography variant="h5">
                <ul className={classes.ul}>
                  <li>Chybí vašemu dítěti motivace ke cvičení?</li>
                  <li>Chybí vám kvaliní a odborné materiály?</li>
                  <li>Nemáte dostatek nápadů ke cvičení?</li>
                  <li>Má vaše dítě zájem o moderní technologie?</li>
                  <li>
                    Chcete si společný čas užít a vytěžit z něho kvalitní
                    komunikaci?
                  </li>
                </ul>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h3" className={classes.sectionHead}>
                Pak je aplikace Logotron právě pro vás!
              </Typography>
              <Typography variant="h5">
                <p>
                  <strong>
                    Každodenní cvičení k rozvoji jakékoli funkce mozku je
                    nutností,
                  </strong>{" "}
                  někdy se však stane, že namísto zábavy a lehkosti, kterou
                  stimulace řeči potřebuje, se objeví nuda, otrava a nezájem. Na
                  straně dítěte a možná i na straně rodiče.
                </p>
                <p>
                  Každá dovednost v našem těle se upevňuje skrze nová nervová
                  spojení v našem mozku. Pozitivní emoce jsou palivem pro tato
                  spojení.{" "}
                  <strong>
                    Když se dítě u cvičení baví a prožívá ho jako hru, jeho
                    mozek se rozvíjí rychleji a vy se můžete také dříve těšit na
                    výsledky, které si přejete.
                  </strong>
                </p>
                <p>Nejen správnou výslovnost.</p>
                <p>
                  A právě s tímto záměrem jsme aplikaci tvořili. Aby vám
                  přinesla kvalitní cvičení, hru a také příjemnou atmosféru.
                </p>
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Container maxWidth="lg" className={classes.section}>
        <Typography variant="h2" className={classes.sectionHead}>
          Pilíře webové aplikace Logotron
        </Typography>
        <Grid container spacing={10}>
          <Grid item sm={6} md={4} xs={12} className={classes.centered}>
            <img
              className={classes.sectionIcon}
              src={certificate}
              alt="Garance klinickou logopedkou"
            />
            <Typography variant="h5" className={classes.pillarHead}>
              CVIČENÍ GARANTOVANÁ KLINICKOU LOGOPEDKOU
            </Typography>
            <Typography variant="subtitle1">
              Martina Kolmanová je autorka mnoha logopedických materiálů,
              pracovních sešitů a kartiček pro rozvoj výslovnosti. Do své práce
              vkládá nejen svůj entusiasmus, celostní pohled ale také dvacet let
              zkušeností v klinické logopedii.
            </Typography>
          </Grid>
          <Grid item sm={6} md={4} xs={12} className={classes.centered}>
            <img
              className={classes.sectionIcon}
              src={celostni}
              alt="Celostní přístup"
            />
            <Typography variant="h5" className={classes.pillarHead}>
              CELOSTNÍ ZAMĚŘENÍ
            </Typography>
            <Typography variant="subtitle1">
              Řeč je komplexem mnoha funkcí těla. A právě proto jsou součástí
              aplikace cvičení na rozvoj zraku, sluchu, paměti, pozornosti,
              myšlení a těla.{" "}
              {/*Součástí aplikace jsou také návodná videa a body
              terapeutické techniky.*/}
            </Typography>
          </Grid>
          <Grid item sm={6} md={4} xs={12} className={classes.centered}>
            <img
              className={classes.sectionIcon}
              src={image}
              alt="Poutavé obrázky"
            />
            <Typography variant="h5" className={classes.pillarHead}>
              POUTAVÉ OBRÁZKY
            </Typography>
            <Typography variant="subtitle1">
              "JSOU TO PRVNÍ OBRÁZKY, U KTERÝCH MOJE DCERA VYDRŽÍ." Veronika
              Kašovská kreslí jednoduché, laskavé a jemné dětské kresby, které
              si získaly velkou odezvu u dětí, které s našimi materiály rády
              pracují a co víc, rády u nich promlouvají.
            </Typography>
          </Grid>
          <Grid item sm={6} md={4} xs={12} className={classes.centered}>
            <img
              className={classes.sectionIcon}
              src={river}
              alt="Cvičení v pohodě"
            />
            <Typography variant="h5" className={classes.pillarHead}>
              NÍZKÁ HLADINA STRESU
            </Typography>
            <Typography variant="subtitle1">
              "UŽ ANI NESLYŠÍM - TO MĚ NEBAVÍ NEBO KDY UŽ BUDE KONEC?" Nízká
              hladina stresu je zajištěna zábavností a lehkostí cvičení, stejně
              jako kvalitně provedenými obrázky, které působí pro mozek dítěte
              jako faktor, který ho otevírá učení a vyšším funkcím, ke kterým
              patří i řeč, paměť a pozornost.
            </Typography>
          </Grid>
          <Grid item sm={6} md={4} xs={12} className={classes.centered}>
            <img
              className={classes.sectionIcon}
              src={brain}
              alt="Pozornost a paměť"
            />
            <Typography variant="h5" className={classes.pillarHead}>
              VYSOKÁ POZORNOST A PAMĚŤ
            </Typography>
            <Typography variant="subtitle1">
              "S LOGOTRONEM JE SAMÝ ÚSMĚV, TĚŠÍ SE NA DALŠÍ HODINU." S nízkou
              hladinou stresu velice úzce souvisí schopnost našeho mozku zaměřit
              pozornost a pamatovat si. Jedno navazuje na druhé.
            </Typography>
          </Grid>
          <Grid item sm={6} md={4} xs={12} className={classes.centered}>
            <img className={classes.sectionIcon} src={apple} alt="Výsledky" />
            <Typography variant="h5" className={classes.pillarHead}>
              VÝSLEDKY, PO KTERÝCH TOUŽÍTE
            </Typography>
            <Typography variant="subtitle1">
              "TAKHLE AKTIVNĚ NA NIC ZATÍM NEREAGOVAL." Učení nevychází z
              drillu, z opakování, z memorování. Vychází ze hry, z radosti a
              vnitřní motivce. Ty mají za úkol nabudit naši pozornost a vedou k
              očekáváným výsledkům.
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Box className={classes.invert}>
        <Container maxWidth="md" className={classes.section}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h3" className={classes.sectionHead}>
                Ukázky aplikace
              </Typography>
            </Grid>
          </Grid>
          <Screenshots />
          {/* 
          <GridList cellHeight={180} cols={3} spacing={35}>
            {SCREENS.map((tile) => (
              <GridListTile key={tile.img} onClick={() => alert("ha")}>
                <div className={classes.galleryThumb}>
                  <img
                    src={SCREENSHOT_IMAGES(`./${tile.img}`).default}
                    alt={tile.label}
                  />
                </div>
                <GridListTileBar title={tile.label} />
              </GridListTile>
            ))}
          </GridList>*/}
        </Container>
      </Box>
      <Container maxWidth="md" className={classes.section}>
        <Typography variant="h3" className={classes.sectionHead}>
          Autorky webové aplikace LOGOTRON
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div style={{ position: "relative" }}>
              <img style={{ maxWidth: "100%" }} src={martina} alt="Martina" />
            </div>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography
              variant="h5"
              className={classes.pillarHead}
              gutterBottom
            >
              Martina Kolmanová
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              klinická logopedka, koučka a yogínka
            </Typography>
            <Typography variant="body1">
              Martina je klinická logopedka s celostním přístupem, autorka
              obrázkových pomůcek na logopedii, e-booků o vývoji řeči, on-line
              kurzů pro děti a také koučka a yogínka a maminka tří dvojjazyčných
              dětí. Má dvacet let zkušeností v klinické logopedii a již pět let
              provozuje on-line logopedickou terapii pro české děti žijící po
              celém světě. A právě z potřeb těchto dětí vznikla aplikace
              Logotron.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div style={{ position: "relative" }}>
              <img style={{ maxWidth: "100%" }} src={veronika} alt="Veronika" />
            </div>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography
              variant="h5"
              className={classes.pillarHead}
              gutterBottom
            >
              Veronika Kašovská
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              grafička a ilustrátorka
            </Typography>
            <Typography variant="body1">
              Veronika je talentovaná grafička, autorka obrázkových materiálů
              Logopedie s úsměvem, které byly vydány nakladatelstvím Euromedia.
              Je také autorka e-shopu Učílek a maminka malého Olivera.
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Box className={classes.invert}>
        <Container maxWidth="lg" className={classes.section}>
          <Typography variant="h3" className={classes.sectionHead}>
            Obsah webové aplikace LOGOTRON
          </Typography>

          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1" gutterBottom>
                Tato aplikace obsahuje{" "}
                <strong>
                  6 hlavních kategorií - ŘEČ, SLUCH, ZRAK, PAMĚŤ, MYŠLENÍ,
                  GRAFOMOTORIKA.
                </strong>{" "}
                Tyto kategorie jsou dále členěné na podkategorie. Např. v
                kategorii Řeč najdete části: Výslovnost, slovní zásoba,
                gramatika, porozumění, vyprávění.
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Podkategorie</strong> obsahují jednotlivá cvičení. Např.{" "}
                <strong>Výslovnost</strong> obsahuje jednotlivé hlásky a k nim
                související úkoly k procvičení - např. slovník na hlásku,
                tvoření množného čísla, předložek, rozlišení pozice hlásky ve
                slově, tvoření vět na hlásku, popis obrázků, logické úlohy a
                hrátky s obrázky.
              </Typography>
              <Typography variant="body1" gutterBottom>
                <ul className={classes.ul}>
                  <li>
                    <strong>Řeč</strong> obsahuje kromě výslovnosti i slovní
                    zásobu obsahující 12 částí dle okruhů slovní zásoby
                    (zvířata, lidské tělo, nářadí,...). Cvičení na gramatiku,
                    kde si děti procvičí skloňování, tvorbu množného čísla,
                    rozpoznávání rodů a použití předložek.
                  </li>
                  <li>
                    <strong>Sluch</strong> obsahuje úkoly na hláskování,
                    slabikování, rytmizaci a tvorbu rýmů.
                  </li>
                  <li>
                    <strong>Zrak</strong> obsahuje úkoly k rozlišení stínových
                    obrázků, konturových obrázků, rozlišení detailu, velikosti,
                    barvy, pravo-levé orientace a cvičení na postřeh. Najdete
                    zde úlohy - doplň dílek do puzzle, najdi 5 rozdílů, zjistit
                    co chybí na obrázku.
                  </li>
                  <li>
                    <strong>Paměť</strong> cvičení na trénink zapamatování si 3
                    - 6 obrázků.
                  </li>
                  <li>
                    <strong>Myšlení</strong> obsahuje cvičení na rozvoj logiky,
                    souvislostí a počítání.
                  </li>
                  <li>
                    <strong>Grafomotorika</strong> cvičení k rozvíjení
                    koordinace oko ruka a pracovní listy k tisku.
                  </li>
                </ul>
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} style={{ textAlign: "center" }}>
              <Typography
                variant="h5"
                style={{
                  background: "#fcdf2c",
                  color: "black",
                  display: "inline-block",
                  padding: "3px 7px",
                }}
              >
                Obsahuje více jak 170 obrázkových cvičení.
              </Typography>
              <img
                style={{ maxWidth: "100%" }}
                src={structure}
                alt="struktura aplikace"
              />
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Container maxWidth="md" className={classes.section}>
        <Typography variant="h3" className={classes.sectionHead}>
          Co o aplikaci říkají rodiče, terapeuti a děti?
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Card>
              <CardContent>
                <Typography variant="subtitle1">
                  Já mám taky jen pozitivní ohlasy...kluk s VD, problém se
                  soustředěním, stále vymyslim jak ho zaujmout, nechce se mu
                  pracovat, zasekne se a nic...Teď do toho on-line. Říkala jsem
                  si, že je to nemožné. Jakmile pracujeme s Logotronem, je samý
                  úsměv, těší se na další hodinu, sám si vybírá co chce dělat
                  “tohle ještě zkusíme...” už ani neslysim “to mě nevadí” nebo
                  “kdy už bude konec”! Naprosto dokonalé. Těším se na “Rozhýbej
                  svůj jazýček” Děkuji, za Vaši práci, že se chcete dělit o
                  zkušenosti a že naplno využíváte svou “superschopnost”
                </Typography>
              </CardContent>
              <CardHeader
                avatar={
                  <Avatar>
                    <FaceRounded />
                  </Avatar>
                }
                title="Lenka"
              />
            </Card>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Card>
              <CardContent>
                <Typography variant="subtitle1">
                  Jsem velmi mile překvapená! Kubíkovi (2,5 roku) se do mluvení
                  moc nechce. Pusu nezastaví, ale rozumět mu není. Nechce ani
                  opakovat slovíčka, ať se snažím o sebezábavnější formu a
                  motivaci. Takže... Spustila jsem appku a hned zkusila myšlení
                  - "Co chybí?" s Kubíkem na klíně. Byl úplně u vytržení.
                  Neříkal, co chybí, protože většinu z toho říct neumí. Ale vždy
                  ukazal správně a když jsem souhlasila a řekla, co ukázal, se
                  smíchem se to snažil zopakovat. Takhle aktivně zatím na nic
                  nereagoval. A co víc! Když jsem zaklapla notebook, spustil
                  hystericky záchvat s proudy slz. No jestli se mu to bude tak
                  moc líbit i dál, budeme muset pořídit i placenou verzi.
                </Typography>
              </CardContent>
              <CardHeader
                avatar={
                  <Avatar>
                    <FaceRounded />
                  </Avatar>
                }
                title="Hana"
              />
            </Card>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Card>
              <CardContent>
                <Typography variant="subtitle1">
                  Učím prvňáčky distančně, což je pro mě zcela nový "level" .
                  Mám zde i děti s OMJ. Logotron mi velmi pomáhá při
                  individuální práci a děti navíc baví! Děkuji.
                </Typography>
              </CardContent>
              <CardHeader
                avatar={
                  <Avatar>
                    <FaceRounded />
                  </Avatar>
                }
                title="Petra"
                subheader="Učitelka"
              />
            </Card>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Card>
              <CardContent>
                <Typography variant="subtitle1">
                  Náš syn sám se o to hlásí, že chce dělat obrázky
                </Typography>
              </CardContent>
              <CardHeader
                avatar={
                  <Avatar>
                    <FaceRounded />
                  </Avatar>
                }
                title="Jana"
              />
            </Card>
          </Grid>
        </Grid>
      </Container>

      <Box className={classes.invert}>
        <Container maxWidth="md" className={classes.section}>
          <Typography variant="h3" className={classes.sectionHead}>
            Jak aplikace funguje?
          </Typography>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={6}>
              <img
                style={{ maxWidth: "100%" }}
                src={howitworks}
                alt="jak aplikace funguje"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="h5" gutterBottom>
                Webovou aplikaci lze použít na vašem počítači nebo i-padu.
              </Typography>

              <Typography variant="body1" gutterBottom>
                Aplikace se spouští ve webovém prohlížeči. Není potřeba nic
                speciálního instalovat. Pro on-line logopedické terapie
                doporučujeme svou obrazovku nasdílet napříkad pomocí služby
                Skype - dítě tak uvidí co přesně mu ukazujete a uslyší vás.
              </Typography>

              <Typography variant="body1" gutterBottom>
                Všechna cvičení v aplikaci jsou statická. Dítě správnou odpověď
                musí vysvětlit nebo ukázat.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Container maxWidth="md" className={classes.section}>
        <Typography variant="h3" className={classes.sectionHead}>
          Ceník Logotronu
        </Typography>
        <Plans />
      </Container>
      <Container maxWidth="sm" className={classes.section}>
        <Typography variant="body1">
          V případě, že chcete Logotron zakoupit do ambulance nebo mateřské
          školy pro více uživatelů, každý uživatel musí mít samostatné členství.
        </Typography>
      </Container>
      <Container
        maxWidth="md"
        className={clsx(classes.section, classes.centered)}
      >
        <Button
          className={classes.login}
          variant="contained"
          color="secondary"
          to="/app"
          component={Link}
        >
          Zakoupit předplatné
        </Button>
      </Container>

      <Container maxWidth="md" className={classes.section}>
        <footer>
          <p>Copyright (c) Martina Kolmanová, Veronika Kašovská</p>
          <p>
            <Link to="/ochrana-osobnich-udaju">Ochrana osobních údajů</Link>
          </p>
        </footer>
      </Container>
    </div>
  );
}
